<template>
  <BCard class="padding-big margin-top-normal">
    <header class="display-flex justify-content-between margin-bottom-normal">
      <span class="font-size-big">{{ author }}</span>
      <span class="font-size-big">{{ formatDate }}</span>
    </header>

    <p class="font-size-big">
      {{ comment }}
    </p>
  </BCard>
</template>

<script>
import ptBR from 'date-fns/locale/pt-BR'
import { format, parseISO } from 'date-fns'
import { BCard } from '@bossabox-code/design-system'

export default {
  name: 'CommentCard',
  components: {
    BCard,
  },
  props: {
    comment: {
      type: String,
      required: true,
    },
    dateTime: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      required: true,
    },
  },
  computed: {
    formatDate() {
      return (this.dateTime && format(parseISO(this.dateTime), 'dd/MM/yyyy HH:mm', { locale: ptBR })) || ''
    },
  },
}
</script>
